module.exports = __webpack_public_path__ + "@/assets/img/chain.03db5975.svg";